import * as MinDateValidators from './datiq-datepicker-min-date.validator';
import * as MaxDateValidators from './datiq-datepicker-max-date.validator';
import * as DateRangeValidators from './datiq-datepicker-range.validator';
import * as MinDaysValidators from './datiq-datepicker-min-days.validtor';
import * as MaxDaysValidators from './datiq-datepicker-max-days.validator';
import * as MinDaysFromValidators from './datiq-datepicker-min-days-away-from.validator';
import * as MaxDaysFromValidators from './datiq-datepicker-max-days-away-from.validator';

const DatiqDatepickerValidators = {
    ...MinDateValidators,
    ...MaxDateValidators,
    ...DateRangeValidators,
    ...MinDaysValidators,
    ...MaxDaysValidators,
    ...MinDaysFromValidators,
    ...MaxDaysFromValidators,
};

export { DatiqDatepickerValidators };
